import { gsap } from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { mapActions } from 'vuex'

export const utilities = {
  methods: {
    ...mapActions(['setListOutOfView']),
    registerGsapPlugins: function() {
      gsap.registerPlugin(ScrollToPlugin, ScrollTrigger)
    },
    scrollIntoView: function(ease = true) {
      gsap.to(window, {
        duration: ease ? 1 : 0,
        ease: 'power1.inOut',
        scrollTo: { y: 0 },
      })
      this.setListOutOfView(false)
    },
    toggleMobileFilterPanel() {
      const panel = document.getElementById('t3m-ObjectiveFinder-filterPanel')
      if (panel) {
        if (panel.classList.contains('show')) {
          panel.classList.remove('show')
          panel.classList.add('!hidden')
        } else {
          panel.classList.add('show')
          panel.classList.remove('!hidden')
        }
      }
      this.scrollIntoView(false);
    },
  },
}
